import axios, { AxiosResponse, CancelToken, AxiosRequestConfig } from 'axios';
import { cashOutDtos, marketingActionsDtos } from '../dtos';
import {
    GetWebStandardEventsResponse,
    IGetWebStandardEventsResponse,
    IGetCouponLineOperationResponse,
    GetCouponLineOperationResponse,
    WebTopBetsWithTs,
    TicketType, StakeType, OddsChangeType, ITicketResponse, TicketDetailResponse, OfferType,
    ITicketListResponse, TicketListResponse, TicketCashOutResponse, TicketSystemsAndCombinations, TicketPrepareResponse, ITicketPrepareResponse,
    CalendarEventsWithTs, GetMobileStandardEventsResponse, IGetMobileStandardEventsResponse, ITicketOneTapBetStartResponse, TicketOneTapBetStartResponse, IGetWebStandardEventExtResponse, GetWebStandardEventExtResponse, IReuseAliveSelectionResponse, ReuseAliveSelectionResponse
} from './proto/apiContract';
import { util } from 'protobufjs';
import { ISportsBettingSessionCommonApi } from './apiSession';
import { IDateTimeFormater } from '../services/dateFormater';
import { IWebTopBetsWithTs, TicketResponse, ITicketConfirmResponse, TicketConfirmResponse, ITicketDetailResponse, TopOfferTypePB, ITicketCancelResponse, TicketCancelResponse } from './proto/apiContract';
import { ISBApiOperationResponse, ISBProtobufApiOperationResponse, SportsBettingApiResult } from './apiCommon';
import { BetDetailApiDto } from '../dtos/apiBetDetailDtos';
import { ILoggingService } from '../services/loggingService';
import { IConnectionMonitorService } from '../services/connectionMonitorService';
import { VideoUrlsResponse } from '../dtos/videoUrlsDtos';
import { ICommonAppSettings, rootCategoryIdToNull, ICalendarEventsWithTs } from 'eTip--common';
import { IRecaptchaProvider } from 'src/modules/eTipCommon/recaptcha/recaptchaProvider';
import { ApiLiveEventsStatusResponse as ApiLiveEventsStatusResponse } from '../dtos/apiLiveEventsDtos';

export interface IBetsListParams {
    BetFilter: number;
    IndexOfPage: number;
    RowsOfPage: number;
}

export interface ITicketSelectionRequest {

    FixtureId: number | Long;

    Id: string;

    OfferType: OfferType;

    Rate: number;

    IsBanker: boolean;
}

export interface ITicketBetRequest {
    Stake: number;
    SelectedSystems: number[];
}

export interface IAmlOptionsRequest {
    Selected: number[];
    UserData: { Key: string, Value: string }[]
}

interface ITicketRequest {
    TicketId?: string;
    HintRefCouponId?: string;
    ProposedStake?: number;
    TicketType: TicketType;
    OfferType: OfferType;
    StakeType: StakeType;
    OddsChangeType: OddsChangeType;
    TicketSelections: ITicketSelectionRequest[];
    Bets: ITicketBetRequest[];
    AMLOptions?: IAmlOptionsRequest;
}

interface ITicketOperationParams {
    Ticket: ITicketRequest;
    AccountTypeId?: string;
    FreeTicketId?: number | Long;
}
export interface ITicketValidateParams extends ITicketOperationParams {
    DoNotReportDifferentRate: boolean;
}

export interface ITicketConfirmParams extends ITicketOperationParams {
}

export interface ITicketDetailParams {
    ticketId: string;
    withEventStatus: boolean;
}

export interface IPublicTicketDetailParams {
    publicId: string;
    withEventStatus: boolean;
}

export interface ITicketByNumberDetailParams {
    ticketNumber: string;
}

export interface ILegacyTicketDetailParams {
    ticketId?: string | null;
    publicId?: string | null;
    ticketNumber?: string | null;
}

export interface ITicketDetailCombinationsParams {
    id: string;
}

export interface ITicketDetailCombinationsByPublicIdParams {
    publicId: string;
}

export interface ITicketCashOutParams {
    ticketId: string;
    rateAcceptChangePercentage: number | null;
    cashout: number;
    cashoutAcceptedChangeType: number | null;
}

interface ITicketCancelParams {
    ticketId: string;
}

export interface IGetWebStandardCategoriesParams {
    parentId?: string;
    from?: Date;
    to?: Date;
    timeStamp?: number;
    includeLiveCategories?: Boolean;
    // <LanguageID>2147483647</LanguageID>
    // <Token>Obsah řetězce</Token>
    // <UseLongPolling>true</UseLongPolling>
    // <From>1999-05-31T11:20:00</From>
    // <TimeFilter>255</TimeFilter>
    // <To>1999-05-31T11:20:00</To>
}

export interface IGetStandardCategories {
    filters: {
        todayCount: number;
        tomorrowCount: number;
        weekCount: number;
    };
    result: number;
    timestamp: number;
}

export interface IGetWebStandardEventsParams {
    categoryId?: string;
    gameIds?: string[];
    from?: Date;
    to?: Date;
    rateFrom?: number;
    rateTo?: number;
    searchBy?: string;
    top?: number;
    skip?: number;
    includeLiveCategories: boolean | null;
}

export interface IGetMobileStandardEventsParams {
    categoryId?: string;
    from?: Date;
    to?: Date;
    includeVMT?: boolean;
    includeLiveCategories: boolean | null;
}

export interface IGetStandartEventParams {
    eventId: number;
    categoryId?: string;
    timeStamp?: number;
}

export interface ISettingsProvider extends ICommonAppSettings {    //TODO to be renamed to AppSettings? it's not provider
    tokenVersion: string;
    serverOffsetMin: number;
    categoriesTreeRefreshTime: number;
    eventDetailRefreshTime: number;
    topBetsRefreshTime: number;
    serverGuid: string;
    drawTipName: string;
}

/**
 * Settings for desktop and mobile web
 */
export interface IWebSettings extends ISettingsProvider {
    canShowVirtualGamesTickets: boolean;
    apiVirtualGamesBaseUrl: string;
    canShowLiveInPrematch: boolean;
    liveEventListRefreshTimeMs: number | null;
    // version: string;
    matchTrackerKey: string;
    canLiveEventsListCollapseSport: boolean;
}

interface IVideoUrlsParams {
    streamId: string;
}

export enum ReportedProblemType {
    Info = 0,
    Warning = 5,
    Error = 10
}
export enum ErrorReportingIntervalsMs {
    OtherErrors = 300000
}

export interface ITicketListParams {
    timeStamp?: number;
    indexOfPage?: number;
    rowsOfPage?: number;
    timeFilter?: TicketListTimeFilterRequest;
    ticketState?: number;
    evalState?: number;
    offerType?: number;
}

export enum TicketListTimeFilterRequest {
    All = 0,
    Day = 1,
    ThreeDays = 2,
    TwoWeeks = 3,
    Month = 4,
    Week = 5,
    Today = 100 //for today bets
}

/**
 * Api request error to distinguish source of error.
 */
export class ApiError extends Error {
    constructor(message: string, _additionalData?: any) {
        super(message);
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}

/**
 * Api returned data but ResponseStatus is not Success.
 */
export class ApiDataError extends Error {

    public result: SportsBettingApiResult;

    constructor(result: SportsBettingApiResult, message: string = "Api response error " + result) {
        super(message);
        Object.setPrototypeOf(this, ApiDataError.prototype);

        this.result = result;
    }
}

export class CancelError extends Error {
    constructor() {
        super("Canceled");
        Object.setPrototypeOf(this, CancelError.prototype);
    }
}

export function getSucceededPromiseAsync(): Promise<void> {
    return new Promise((f, _r) => {
        f();
    });
}

export function getFailedPromiseAsync(reason: Error): Promise<void> {
    return new Promise((_f, r) => {
        r(reason);
    });
}

export function prepareAxiosConfig(cancelToken: CancelToken, isDebug: boolean): AxiosRequestConfig {
    return {
        cancelToken: cancelToken,
        timeout: isDebug ? 120000 : 30000
    }
}

export type IApiDate2StringConverter = (value: string | null) => Date;

//TODO fix number to correct enum
export interface ISportsBettingBaseApi {
    getServerTimeAsyncForTipos(withTokenCheck?: boolean): Promise<Date>;
    getWebStandardEventsAsync: (params: IGetWebStandardEventsParams) => Promise<IGetWebStandardEventsResponse | null>;
    getMobileStandardEventsAsync: (params: IGetMobileStandardEventsParams) => Promise<IGetMobileStandardEventsResponse | null>;
    getWebStandardEventAsync: (params: IGetStandartEventParams) => Promise<IGetWebStandardEventExtResponse | null>;
    getFavoriteEventsAsync: (params: IGetWebStandardEventsParams) => Promise<IGetWebStandardEventsResponse | null>;
    getWebTopBetsAsync: (type: number, typeAdditionalData: string | null, timestamp: number) => Promise<ISBApiOperationResponse<IWebTopBetsWithTs>>;
    processApiResponse(response: AxiosResponse<ISBApiOperationResponse<any>>, errorHandler: (reason: Error) => void): boolean;
    processError(error: any, errorHandler: (reason: Error) => void): void;
    toDate(date: string | null): Date; //IApiDate2StringConverter
    dateToString(date: Date): string;
    cashOutSubmitAsync?: (params: cashOutDtos.CashOutSubmitParams) => Promise<cashOutDtos.CashOutSubmitResponse>;
    getBetDetailAsync: (id: number, legacySBUrl: string) => Promise<ISBApiOperationResponse<BetDetailApiDto>>; //legacy Tipos bet detail TODOHMTS
    getBetDetailPublicAsync: (id: string, legacySBUrl: string) => Promise<ISBApiOperationResponse<BetDetailApiDto>>; //legacy Tipos bet detail TODOHMTS
    createBuffer?: (data: string) => Uint8Array;
    isEncodedNull: (data: string) => boolean;
    getOtherTipsAsync?: (eventId: number, lineNumber: number) => Promise<IGetCouponLineOperationResponse>;
    reportProblemToServer(type: ReportedProblemType, message: string, intervalMs: Number): void;
    reportInfoToServer(type: ReportedProblemType, message: string): void;
    getMarketingActionAsync?: () => Promise<marketingActionsDtos.MarketingActionsResponse>;
    getVideoUrlsAsync: (params: IVideoUrlsParams) => Promise<VideoUrlsResponse>;
    ticketValidateAsync: (params: ITicketValidateParams) => Promise<ITicketResponse>;
    ticketPayAsync: (params: ITicketConfirmParams) => Promise<ITicketConfirmResponse>;
    ticketPrepareAsync: (params: ITicketOperationParams) => Promise<ITicketPrepareResponse>
    ticketDetailAsync: (params: ITicketDetailParams) => Promise<ITicketDetailResponse>;
    publicTicketDetailAsync(params: IPublicTicketDetailParams): Promise<ITicketDetailResponse>;
    ticketByNumberDetailAsync(params: ITicketByNumberDetailParams): Promise<ITicketDetailResponse>;
    legacyTicketDetailAsync: (params: ILegacyTicketDetailParams, legacySBUrl: string) => Promise<string | null>
    getTicketSystemCombinationsAsync: (params: ITicketDetailCombinationsParams) => Promise<TicketSystemsAndCombinations>;
    getTicketSystemCombinationsByPublicIdAsync: (params: ITicketDetailCombinationsByPublicIdParams) => Promise<TicketSystemsAndCombinations>;
    getTicketListAsync: (params: ITicketListParams) => Promise<ITicketListResponse>;
    ticketCashOutSubmitAsync: (params: ITicketCashOutParams) => Promise<TicketCashOutResponse>
    getUpcomingLiveEventsAsync: (timestamp: number) => Promise<ICalendarEventsWithTs>;
    ticketOneTapBetStartAsync: (proposedStake: number) => Promise<ITicketOneTapBetStartResponse>;
    ticketCancelAsync: (params: ITicketCancelParams) => Promise<ITicketCancelResponse>;
    reuseAliveSelectionsAsync: (params: ITicketDetailParams) => Promise<IReuseAliveSelectionResponse>;
    reusePublicAliveSelectionsAsync: (params: IPublicTicketDetailParams) => Promise<IReuseAliveSelectionResponse>;
    getLiveEventsStatusAsync: (ids: number[], timestamp: number | null) => Promise<ApiLiveEventsStatusResponse>;
}

export interface IConnectSportsBettingBaseApiParams {
    dateTimeFormater: IDateTimeFormater;
    baseUrl: string;
    sessionApi: ISportsBettingSessionCommonApi;
    settings: ISettingsProvider;
    token: string;
}

export function sportsBettingBaseApi(apiParams: IConnectSportsBettingBaseApiParams, loggingService: ILoggingService,
    connectionMonitorService: IConnectionMonitorService, recaptchaProvider: IRecaptchaProvider, defaultConfig?: AxiosRequestConfig): ISportsBettingBaseApi {
    const baseUrl = `${apiParams.baseUrl}/WebServices/Api/SportsBettingService.svc`;
    const languageId = apiParams.settings.language.id;
    const toDate = apiParams.dateTimeFormater.toDate;
    const dateToString = apiParams.dateTimeFormater.toString;
    let lastReportedByType: Map<string, number> = new Map<string, number>();

    function processApiResponse(response: AxiosResponse<ISBApiOperationResponse<any>>, errorHandler: (reason: Error) => void, canSendSuccessToMonitor: boolean = true): boolean {
        if (response.data.Result == SportsBettingApiResult.Failed) {
            loggingService.error('Request failed', response.data);
            errorHandler(new ApiDataError(SportsBettingApiResult.Failed));
            return false;
        } else {
            if (response.data.Result == SportsBettingApiResult.SessionExpired) {
                apiParams.sessionApi.tokenExpired();
                errorHandler(new ApiDataError(SportsBettingApiResult.SessionExpired));
                return false;
            }
        }
        apiParams.sessionApi.tokenOk();
        if (canSendSuccessToMonitor) {
            connectionMonitorService.heartbeatSuccess();
        }
        return true;
    }

    function processError(error: any, errorHandler: (reason: any) => void) {
        if (axios.isCancel(error)) {
            errorHandler(new CancelError());
            return;
        };
        if (error instanceof Error) {
            errorHandler(new ApiError(error.message));
            return;
        }
        if (typeof (error) === 'string') {
            errorHandler(new ApiError(error));
            return;
        }
        errorHandler(new ApiError("An error in request"/*, error*/));
    }

    function createBuffer(data: string) {
        let b = new Uint8Array(util.base64.length(data));
        util.base64.decode(data, b, 0);
        return b;
    }

    /**
     * Expected for Tipos only. For MTS use getServerTimeAsync in ApiSession
     */
    function getServerTimeAsyncForTipos(withTokenCheck?: boolean) {
        return new Promise<Date>((f, r) => {
            axios
                .post(
                    `${baseUrl}/getServerTime`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        WithTokenCheck: withTokenCheck === true ? true : undefined
                    },
                    defaultConfig
                )
                .then(response => {
                    if (processApiResponse(response, r)) {
                        f(toDate(response.data.ReturnValue));
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getWebStandardEventAsync(params: IGetStandartEventParams) {
        return new Promise<IGetWebStandardEventExtResponse | null>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetWebStandardEventExt`,
                    {
                        EventID: params.eventId,
                        // really do not send CategoryID, see https://synottech.atlassian.net/browse/TIPOS-12154
                        LanguageID: languageId,
                        Token: apiParams.token,
                        UseLongPolling: true,
                        TimeStamp: params.timeStamp
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.NoChange) {
                            f(null);
                        } else {
                            let responseValue = GetWebStandardEventExtResponse.decode(createBuffer(response.data.ReturnValue));
                            f(responseValue);
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getWebStandardEventsAsync(params: IGetWebStandardEventsParams): Promise<IGetWebStandardEventsResponse | null> {
        return new Promise<IGetWebStandardEventsResponse | null>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetWebStandardEvents`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        // UseLongPolling: true,
                        CategoryID: rootCategoryIdToNull(params.categoryId),
                        GameIds: params.gameIds,
                        // TimeFilter: 255,
                        From: params.from && dateToString(params.from),
                        To: params.to && dateToString(params.to),
                        OddsFrom: params.rateFrom,
                        OddsTo: params.rateTo,
                        SearchTerm: params.searchBy,
                        Top: params.top,
                        Skip: params.skip,
                        IncludeLiveCategories: params.includeLiveCategories
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        const responseValue = GetWebStandardEventsResponse.decode(createBuffer(response.data.ReturnValue))
                        f(responseValue);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getMobileStandardEventsAsync(params: IGetMobileStandardEventsParams): Promise<IGetMobileStandardEventsResponse | null> {
        return new Promise<IGetMobileStandardEventsResponse | null>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetMobileStandardEvents`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        // UseLongPolling: true,
                        CategoryID: rootCategoryIdToNull(params.categoryId),
                        From: params.from && dateToString(params.from),
                        To: params.to && dateToString(params.to),
                        IncludeVMT: params.includeVMT,
                        IncludeOriginalCategoriesForVirtualCategories: params.includeLiveCategories
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        const responseValue = GetMobileStandardEventsResponse.decode(createBuffer(response.data.ReturnValue))
                        f(responseValue);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getWebTopBetsAsync(type: TopOfferTypePB, typeAdditionalData: string | null, timestamp: number) {
        return new Promise<ISBApiOperationResponse<IWebTopBetsWithTs>>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetWebTopBets`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        TopOfferType: type,
                        TypeAddData: typeAdditionalData,
                        TimeStamp: timestamp
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result == SportsBettingApiResult.NoChange) {
                            f({ Result: SportsBettingApiResult.NoChange, ReturnValue: null });
                            return;
                        }
                        f({ Result: SportsBettingApiResult.Success, ReturnValue: WebTopBetsWithTs.decode(createBuffer(response.data.ReturnValue)) });
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getBetDetailAsync(id: number, legacySBUrl: string) {
        return new Promise<ISBApiOperationResponse<BetDetailApiDto>>((f, r) => {
            axios
                .post(
                    //`${baseUrl}/BetDetail`,
                    `${legacySBUrl}/webservices/api/SportsBettingService.svc/BetDetail`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Bet: { ID: id }
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBApiOperationResponse<BetDetailApiDto>>) => {
                    if (processApiResponse(response, r)) {
                        f(response.data);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getBetDetailPublicAsync(id: string, legacySBUrl: string) {
        return new Promise<ISBApiOperationResponse<BetDetailApiDto>>((f, r) => {
            axios
                .post(
                    `${legacySBUrl}/webservices/api/SportsBettingService.svc/BetDetailPbl`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        PblId: id
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBApiOperationResponse<BetDetailApiDto>>) => {
                    if (processApiResponse(response, r)) {
                        f(response.data);
                    }
                })
                .catch(error => {
                    if (axios.isCancel(error)) return;
                    r(error);
                });
        });
    }

    function getFavoriteEventsAsync(params: IGetWebStandardEventsParams): Promise<IGetWebStandardEventsResponse | null> {
        return new Promise<IGetWebStandardEventsResponse | null>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetWebFavoriteEvents`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        // UseLongPolling: true,
                        CategoryID: rootCategoryIdToNull(params.categoryId),
                        GameIds: params.gameIds,
                        // TimeFilter: 255,
                        From: params.from && dateToString(params.from),
                        To: params.from && dateToString(params.to),
                        RateFrom: params.rateFrom,
                        RateTo: params.rateTo,
                        SearchTerm: params.searchBy,
                        Top: params.top,
                        Skip: params.skip,
                        IncludeLiveCategories: params.includeLiveCategories
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(GetWebStandardEventsResponse.decode(createBuffer(response.data.ReturnValue)));
                        } else {
                            f(null);
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getOtherTipsAsync(eventId: number, lineNumber: number) {
        return new Promise<IGetCouponLineOperationResponse | null>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetCouponLine`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        EventId: eventId,
                        LineNumber: lineNumber
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBApiOperationResponse<any>>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(GetCouponLineOperationResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function reportProblemToServer(type: ReportedProblemType, message: string, intervalMs: number) {
        try {
            let ts = new Date().getTime();
            let key = ReportedProblemType.Error + '#' + message.length;
            let lastReport = lastReportedByType.get(key);
            if (lastReport === undefined || ts - intervalMs > lastReport) {
                axios.post(
                    `${baseUrl}/LiveReportProblem`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Type: type,
                        Message: message
                    },
                    defaultConfig
                );
                lastReportedByType.set(key, ts);
            }
        } catch (e) {
            console.log('Error sending error to server: ' + e.message);
        }
    }

    function reportInfoToServer(type: ReportedProblemType, message: string) {
        try {
            axios.post(
                `${baseUrl}/LiveReportProblem`,
                {
                    LanguageID: languageId,
                    Token: apiParams.token,
                    Type: type,
                    Message: message
                },
                defaultConfig
            );
        } catch (e) {
            console.log('Error sending error to server: ' + e.message);
        }
    }

    function isEncodedNull(data: string) {
        return data === "";
    }

    function getMarketingActionAsync() {
        return new Promise<marketingActionsDtos.MarketingActionsResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetMarketingAction`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBApiOperationResponse<marketingActionsDtos.MarketingActionsResponse>>) => {
                    if (processApiResponse(response, r)) {
                        f(response.data.ReturnValue);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getVideoUrlsAsync(params: IVideoUrlsParams) {
        return new Promise<VideoUrlsResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetVideoUrls`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        StreamId: params.streamId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<any>) => {  // VideoUrlsResponse values are inside response.data, not in return value
                    if (processApiResponse(response, r)) {
                        f(response.data);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function ticketValidateAsync(params: ITicketValidateParams): Promise<ITicketResponse> {
        return new Promise<ITicketResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketValidate`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Ticket: params.Ticket,
                        AccountTypeId: params.AccountTypeId,
                        FreeTicketId: params.FreeTicketId,
                        DoNotReportDifferentRate: params.DoNotReportDifferentRate
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            // console.log(TicketResponse.decode(createBuffer('CjApUrgehetRGkA6DQgDIAEpAAAAAADAYkA6DQgBIAMpAAAAAAAASUBRAAAAAAAAaUASGwoQCI6MBRFSuB6F61HwPyoBQRFSuB6F61HwPxIaCg8I/QQR4XoUrkfhDkAqAUIR4XoUrkfhDkASGgoPCNAVEVyPwvUoXBFAKgFDEVyPwvUoXBFA')));
                            // console.log(TicketResponse.decode(createBuffer(response.data.ReturnValue)));
                            f(TicketResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    async function ticketPayAsync(params: ITicketConfirmParams): Promise<ITicketConfirmResponse> {
        var recaptchaResponse = await recaptchaProvider.ScoreAction("TicketPay");

        return new Promise<ITicketConfirmResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketPay`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Ticket: params.Ticket,
                        AccountTypeId: params.AccountTypeId,
                        FreeTicketId: params.FreeTicketId,
                        RecaptchaResponse: recaptchaResponse
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketConfirmResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function ticketPrepareAsync(params: ITicketOperationParams): Promise<ITicketPrepareResponse> {
        return new Promise<ITicketPrepareResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketPrepare`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Ticket: params.Ticket,
                        AccountTypeId: params.AccountTypeId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketPrepareResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function ticketDetailAsync(params: ITicketDetailParams): Promise<ITicketDetailResponse> {
        return new Promise<ITicketDetailResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetTicketDetail`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Bet: { ID: params.ticketId },
                        WithEventStatus: params.withEventStatus

                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(isEncodedNull(response.data.ReturnValue) ? null : TicketDetailResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function reuseAliveSelectionsAsync(params: ITicketDetailParams): Promise<IReuseAliveSelectionResponse> {
        return new Promise<IReuseAliveSelectionResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/ReuseAliveSelections`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        TicketId: params.ticketId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(isEncodedNull(response.data.ReturnValue) ? null : ReuseAliveSelectionResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function reusePublicAliveSelectionsAsync(params: IPublicTicketDetailParams): Promise<IReuseAliveSelectionResponse> {
        return new Promise<IReuseAliveSelectionResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/ReusePublicAliveSelections`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        PublicId: params.publicId,
                        WithEventStatus: params.withEventStatus
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(isEncodedNull(response.data.ReturnValue) ? null : ReuseAliveSelectionResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function publicTicketDetailAsync(params: IPublicTicketDetailParams): Promise<ITicketDetailResponse> {
        return new Promise<ITicketDetailResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetPublicTicketDetail`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        PublicId: params.publicId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(isEncodedNull(response.data.ReturnValue) ? null : TicketDetailResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function ticketByNumberDetailAsync(params: ITicketByNumberDetailParams): Promise<ITicketDetailResponse> {
        return new Promise<ITicketDetailResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetTicketByNumberDetail`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        TicketNumber: params.ticketNumber
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(isEncodedNull(response.data.ReturnValue) ? null : TicketDetailResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function legacyTicketDetailAsync(params: ILegacyTicketDetailParams, legacySBUrl: string): Promise<string | null> {
        return new Promise<string>((f, r) => {

            let additional;
            if (params.ticketId) {
                additional = "BetID=" + encodeURI(params.ticketId);
            } else if (params.publicId) {
                additional = "Identifier=" + encodeURI(params.publicId);
            }
            else if (params.ticketNumber) {
                additional = "Number=" + encodeURI(params.ticketNumber);
            }
            else {
                throw new Error("Unexpected params");
            }

            axios
                .get(`${legacySBUrl}/CouponDetailLegacy.aspx?${additional}`, { ...defaultConfig, withCredentials: true })
                //experiment  "http://sport.synottip.ebet.localhost/CouponDetail.aspx?BetID=1576509371", { ...defaultConfig, withCredentials: true })
                .then((response: AxiosResponse<string>) => {
                    if (response.data && response.data.length > 20) {

                        let lowerContent = response.data.toLowerCase();
                        if (lowerContent.indexOf("<script") >= 0) {
                            processError(new Error("Content problem, posible XSS"), r);
                            return;
                        }
                        if (lowerContent.indexOf("<body") >= 0) {
                            processError(new Error("Content problem, unexpected body start"), r);
                            return;
                        }
                        f(response.data);
                    } else {
                        f(null);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getTicketSystemCombinationsAsync(params: ITicketDetailCombinationsParams): Promise<TicketSystemsAndCombinations> {
        return new Promise<TicketSystemsAndCombinations>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetTicketDetailSystemCombinations`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        Bet: { ID: params.id }
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketSystemsAndCombinations.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getTicketSystemCombinationsByPublicIdAsync(params: ITicketDetailCombinationsByPublicIdParams): Promise<TicketSystemsAndCombinations> {
        return new Promise<TicketSystemsAndCombinations>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetTicketDetailSystemCombinationsByPublicId`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        PublicId: params.publicId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketSystemsAndCombinations.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    const getTicketListAsync = (params: ITicketListParams) => {
        return new Promise<ITicketListResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetTicketList`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        RowsOfPage: params.rowsOfPage,
                        IndexOfPage: params.indexOfPage,
                        TimeFilter: params.timeFilter,
                        TicketState: params.ticketState,
                        EvalState: params.evalState,
                        OfferType: params.offerType
                    },
                    defaultConfig
                )
                .then(response => {
                    if (processApiResponse(response, r)) {
                        f(TicketListResponse.decode(createBuffer(response.data.ReturnValue)));
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    const ticketCashOutSubmitAsync = (params: ITicketCashOutParams): Promise<TicketCashOutResponse> => {

        const specConfig = { ...defaultConfig };
        specConfig.timeout = 120000;

        return new Promise<TicketCashOutResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketCashOutSubmit`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        TicketId: params.ticketId,
                        RateAcceptChangePercentage: params.rateAcceptChangePercentage,
                        Cashout: params.cashout,
                        CashoutAcceptedChangeType: params.cashoutAcceptedChangeType
                    },
                    specConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketCashOutResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    const getUpcomingLiveEventsAsync = (timestamp: number): Promise<ICalendarEventsWithTs> => {
        return new Promise<ICalendarEventsWithTs>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetLiveUpcomingEvents`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        UseLongPolling: true,
                        TimeStamp: timestamp
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(CalendarEventsWithTs.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    const ticketOneTapBetStartAsync = (proposedStake: number): Promise<ITicketOneTapBetStartResponse> => {
        return new Promise<ITicketOneTapBetStartResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketOneTapBetStart`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        ProposedStake: proposedStake
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            const x = TicketOneTapBetStartResponse.decode(createBuffer(response.data.ReturnValue))
                            f(x);
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function cancelTicketAsync(params: ITicketCancelParams): Promise<ITicketCancelResponse> {
        return new Promise<ITicketCancelResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/TicketCancel`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        TicketId: params.ticketId
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ISBProtobufApiOperationResponse>) => {
                    if (processApiResponse(response, r)) {
                        if (response.data.Result === SportsBettingApiResult.Success) {
                            f(TicketCancelResponse.decode(createBuffer(response.data.ReturnValue)));
                        }
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    function getLiveEventsStatusAsync(ids: number[], timestamp: number | null): Promise<ApiLiveEventsStatusResponse> {
        return new Promise<ApiLiveEventsStatusResponse>((f, r) => {
            axios
                .post(
                    `${baseUrl}/GetLiveEventsStatus`,
                    {
                        LanguageID: languageId,
                        Token: apiParams.token,
                        UseLongPolling: true,
                        Ids: ids,
                        TimeStamp: timestamp
                    },
                    defaultConfig
                )
                .then((response: AxiosResponse<ApiLiveEventsStatusResponse>) => {
                    if (processApiResponse(response, r)) {
                        f(response.data);
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }

    return {
        getServerTimeAsyncForTipos,
        getWebStandardEventAsync,
        getWebStandardEventsAsync,
        getMobileStandardEventsAsync,
        getFavoriteEventsAsync,
        getWebTopBetsAsync,
        processApiResponse,
        processError,
        toDate,
        dateToString,
        getBetDetailAsync,
        getBetDetailPublicAsync,
        createBuffer,
        isEncodedNull,
        getOtherTipsAsync,
        reportProblemToServer,
        reportInfoToServer,
        getMarketingActionAsync,
        getVideoUrlsAsync,
        ticketValidateAsync,
        ticketPayAsync,
        ticketDetailAsync,
        publicTicketDetailAsync,
        ticketByNumberDetailAsync,
        legacyTicketDetailAsync,
        getTicketSystemCombinationsAsync,
        getTicketSystemCombinationsByPublicIdAsync,
        getTicketListAsync,
        ticketCashOutSubmitAsync,
        ticketPrepareAsync,
        getUpcomingLiveEventsAsync,
        ticketOneTapBetStartAsync,
        ticketCancelAsync: cancelTicketAsync,
        reuseAliveSelectionsAsync,
        reusePublicAliveSelectionsAsync,
        getLiveEventsStatusAsync
    };
}

export function errorIsSessionExpired(error: any): boolean {
    return error instanceof ApiDataError && (<ApiDataError>error).result === SportsBettingApiResult.SessionExpired;
};

export function errorIsCancel(error: any): boolean {
    return error instanceof CancelError;
}

export function errorIsInApiRequest(error: any): boolean {
    return error instanceof ApiError || error instanceof ApiDataError;
}
